import { Component, ViewEncapsulation, ViewChild, HostListener, OnInit } from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { ModalDirective } from 'ngx-bootstrap';
import { AuthService } from '../../core/auth/auth.service'
import { CustomerService } from '../../core/customer/customer.service';
import { CustomerModel } from '../../core/customer/customer.model';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-root',
  templateUrl: 'landing-layout.component.html',
  styleUrls: ['landing-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LandingLayoutComponent implements OnInit {
  @ViewChild('signinPop') signinPop: PopoverDirective;
  isOpen = false;
  //customer: CustomerModel;
  lengthShoppingCart = 0;

  @ViewChild("signupModal") signupModal: ModalDirective;

  constructor(
    public auth: AuthService,
    private _customerService: CustomerService,
    private _router: Router) {

  }

  messages = [];
 
  display = true;

  customer: any = null;
  

  ngOnInit() {

    
    //this.auth.user = customer;
  }

  goToPlay(game: string) {
    if (_.isEqual(game, 'melate')) {
      this._router.navigate(['juegos/melateStepOne']);
    }
  }

  logout() {
    this.auth.logout()
    .finally(() => this._router.navigate(['landing/home']))
    .subscribe();
  }

  showProfile() {
    this._router.navigate(['juegos/management-profile']);
  }

  openMenu() {
    this.isOpen = this.isOpen ? false : true;
  }

  onSignin(event) {
    this.signinPop.hide();
    this.isOpen = false;
    this.setEvent(event);
  }

  onSignup(event) {
    this.setEvent(event);
  }

  setEvent(event) {
    console.log(event);
    if (event && event.username){
      this.signupModal.show();
      this.customer = event;
    }else if (event && event.message)
      this.messages.push({ severity: 'error', summary: '', detail: event.message });
  }

  success($event){
    this.signupModal.hide();
  }

  toggleSigninPop() {
    this.signinPop.toggle();
  }

  toggleSignupPop() {
    this.signinPop.hide();
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/landing-layout/landing-layout.component.ts